const OPERATIONS = {
  ALL: 'all',
  ANY: 'any',
  EXACTLY: 'exactly'
};

export default OPERATIONS;
